import { ChangeEvent, useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import Form from "react-bootstrap/Form";
import {
    OIDC_CREATEACCOUNT_SERVICE_TYPE,
    OIDC_LOGIN_SERVICE_TYPE
} from "@constants/verification-service-types";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { CardContainer } from "@containers/common/card-container/card-container";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import commonStyles from "../../verification-service-details-component.less";
import styles from "./service-type-tab-container.less";

type ServiceTypeTabContainerProps = {
    isDisabled: boolean;
    rpServiceConfigurationState: FormattedRpServiceConfiguration;
    setRpServiceConfigurationState: (state: FormattedRpServiceConfiguration) => void;
};

export const ServiceTypeTabContainer = (props: ServiceTypeTabContainerProps) => {
    const { rpServiceConfigurationState, isDisabled, setRpServiceConfigurationState } = props;

    const selectedServiceType = useMemo(() => {
        //todo figure this out
        if (rpServiceConfigurationState.serviceType === OIDC_LOGIN_SERVICE_TYPE) {
            return "sso";
        } else if (rpServiceConfigurationState.serviceType === OIDC_CREATEACCOUNT_SERVICE_TYPE) {
            return "uvo";
        } else {
            return null;
        }
    }, [rpServiceConfigurationState.serviceType]);

    const onChangeServiceType = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "sso" && selectedServiceType !== "sso") {
            setRpServiceConfigurationState({
                ...rpServiceConfigurationState,
                serviceType: OIDC_LOGIN_SERVICE_TYPE
            });
        } else if (event.target.value === "uvo" && selectedServiceType !== "uvo") {
            setRpServiceConfigurationState({
                ...rpServiceConfigurationState,
                serviceType: OIDC_CREATEACCOUNT_SERVICE_TYPE
            });
        }
    };

    return (
        <div className={styles.serviceTypeTabContainer}>
            <ContentPageHeader title={resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.title} />
            <ContentPageBody isMaxWidth={true}>
                <span className={commonStyles.description}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.description}</span>
                <div className={styles.multiCardContainer}>
                    <CardContainer className={styles.cardContainer}>
                        <span className={styles.cardHeader}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.sso.title}</span>
                        <span className={styles.cardDescription}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.sso.description}</span>
                        <Form.Check
                            id={`sso-service-type-radio`}
                            automation-id={`sso-service-type-radio`}
                            required={false}
                            aria-label={resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.sso.title}
                            label={resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.sso.title}
                            onChange={onChangeServiceType}
                            type={"radio"}
                            name={""}
                            value={"sso"}
                            checked={selectedServiceType === "sso"}
                            disabled={isDisabled}
                        />
                    </CardContainer>
                    <CardContainer className={styles.cardContainer}>
                        <span className={styles.cardHeader}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.uvo.title}</span>
                        <span className={styles.cardDescription}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.uvo.description}</span>
                        <Form.Check
                            id={`uvo-service-type-radio`}
                            automation-id={`uvo-service-type-radio`}
                            required={false}
                            aria-label={resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.uvo.title}
                            label={resources.pages.verificationServiceDetails.tabs.general.subTabs.serviceType.uvo.title}
                            onChange={onChangeServiceType}
                            type={"radio"}
                            name={""}
                            value={"uvo"}
                            checked={selectedServiceType === "uvo"}
                            disabled={isDisabled}
                        />
                    </CardContainer>
                </div>
            </ContentPageBody>
        </div>
    );
};